import { Marker, Popup } from 'react-leaflet'
import { Icon } from 'leaflet'
import { Locale } from '../../types'
import MarkerPopup from './MarkerPopup'

interface LocaleMarkerProps {
  locale: Locale
  isSelected?: boolean
  onClick?: () => void
}

// Icona marker custom per i locali con logo Conero Garage
const createMarkerIcon = (isSelected: boolean): Icon => {
  const size = isSelected ? 48 : 36

  return new Icon({
    iconUrl: '/images/logoscontornato.png',
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
    popupAnchor: [0, -size],
    className: isSelected ? 'marker-selected' : 'marker-default',
  })
}

/**
 * Marker personalizzato per un locale sulla mappa
 * Include popup con informazioni base e link al dettaglio
 */
export default function LocaleMarker({
  locale,
  isSelected = false,
  onClick,
}: LocaleMarkerProps) {
  return (
    <Marker
      position={[locale.latitudine, locale.longitudine]}
      icon={createMarkerIcon(isSelected)}
      eventHandlers={{
        click: onClick,
      }}
    >
      <Popup>
        <MarkerPopup locale={locale} />
      </Popup>
    </Marker>
  )
}
